/// <amd-module name="Feed/Legacy/DataServices/BuildDataService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";

import { Build } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { getOrganizationAsync, isCurrentCollection } from "Feed/Legacy/Helpers/OrganizationHelper";

export interface IFeedBuildDataService extends IVssService {
    getBuildAsync(collectionId: string, projectId: string, buildId: number): Promise<Build>;
}

class BuildDataService extends VssService implements IFeedBuildDataService {
    public async getBuildAsync(collectionId: string, projectId: string, buildId: number): Promise<Build> {
        return this.getBuildRestClientAsync(collectionId).then((client: IBuildRestClient) => {
            return client.getBuild(projectId, buildId);
        });
    }

    private async getBuildRestClientAsync(collectionId: string): Promise<IBuildRestClient> {
        if (isCurrentCollection(this.pageContext, collectionId)) {
            return this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        }

        const org = await getOrganizationAsync(this.pageContext, collectionId);
        if (org == null) {
            throw { message: "Organization " + collectionId + "not found.", status: 404 };
        }

        return this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient", { rootPath: org.url });
    }
}

Services.add("IFeedBuildDataService", { serviceFactory: BuildDataService });
